import { CountryDto } from "@cradua/data";
import { createAction, props } from "@ngrx/store";
import { IsNumber } from "class-validator";

/**
 * Load Generic Collection Actions
 */

export const documentUploadRequest = createAction(
  "[Documents] Upload Documents",
  props<{ file: File; document: any[] }>(),
);

export const documentUploadCancel = createAction(
  "[Documents Upload Cancel] Cancel",
);

export const documentUploadReset = createAction(
  "[Documents Upload Reset] Reset",
);

export const documentUploadStarted = createAction(
  "[Documents Upload API] Started",
);

export const documentUploadProgress = createAction(
  "[Documents Upload API] Progress",
  props<{ progress: number }>(),
);

export const documentUploadFailure = createAction(
  "[Documents Upload API] Failure",
  props<{ error: any }>(),
);

export const documentUploadSuccess = createAction(
  "[Documents Upload API]  Success",
);

export const documentUploadCompleted = createAction(
  "[Documents Upload API]  Completed",
);

export function loadEpimsgate(actionType: string) {
  //console.log("Reaching Load Action ", actionType);
  const newLoadAction = createAction(
    `[${actionType}] Load ${actionType} Load`,
    props<{ modeltype: string }>(),
  );
  return newLoadAction;
}

export function loadEpimsgateSuccess(actionType: string) {
  const loadSuccess = createAction(
    `[${actionType}] Load ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
  );
  return loadSuccess;
}

export function loadEpimsgateFailure(actionType: string) {
  const loadFailure = createAction(
    `[${actionType}] Load ${actionType} Data Failure`,
    props<{ error: any }>(),
  );
  return loadFailure;
}

export function loadByIdEpimsgate(actionType: string) {
  return createAction(
    `[${actionType}] Load ${actionType} Data`,
    props<{ modeltype: string; id: string }>(),
  );
}

export function loadByIdEpimsgateSuccess(actionType: string) {
  return createAction(
    `[${actionType}] Load ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
  );
}

export function loadByIdEpimsgateFailure(actionType: string) {
  return createAction(
    `[${actionType}] Load ${actionType} Data Failure`,
    props<{ error: any }>(),
  );
}

export function addViaEpimsgate(actionType: string) {
  return createAction(
    `[${actionType}] Add ${actionType} Data`,
    props<{ dataToAdd: any[]; modelType: string }>(),
  );
}

export function addViaEpimsgateSuccess(actionType: string) {
  return createAction(
    `[${actionType}] Add ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
  );
}

export function addViaEpimsgateFailure(actionType: string) {
  return createAction(
    `[${actionType}] Add ${actionType} Data Failure`,
    props<{ error: any }>(),
  );
}

export function removeViaEpimsgate(actionType: string) {
  return createAction(
    `[${actionType}] Remove ${actionType} Data`,
    props<{ ids: string[]; modelType: string }>(),
  );
}

export function removeViaEpimsgateSuccess(actionType: string) {
  return createAction(
    `[${actionType}] Remove ${actionType} Data Success`,
    props<{ ids: string[] }>(),
  );
}

export function removeViaEpimsgateFailure(actionType: string) {
  return createAction(
    `[${actionType}] Remove ${actionType} Data Failure`,
    props<{ error: any }>(),
  );
}

export function updateViaEpimsgate(actionType: string) {
  return createAction(
    `[${actionType}] Update ${actionType} Data`,
    props<{ dataToAdd: any[]; deletedData: any[]; modelType: string }>(),
  );
}

export function updateViaEpimsgateSuccess(actionType: string) {
  return createAction(
    `[${actionType}] Update ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
  );
}

export function updateViaEpimsgateFailure(actionType: string) {
  return createAction(
    `[${actionType}] Update ${actionType} Data Failure`,
    props<{ error: any }>(),
  );
}
